<template>
  <v-card class="card--shadow">
    <v-card-title class=" purple accent-4">
      <div class="subtitle-1 white--text">
        Region Form
      </div>
    </v-card-title>
    <v-card-text class="pt-4">
      <label>Region</label>
      <v-text-field
        v-model.trim="region.name"
        :error-messages="nameErrors"
        type="text"
        outlined
        dense
      ></v-text-field>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="region.id" @click.prevent="emitRegionData" class="form-btn">
        Update
      </v-btn>
      <v-btn v-else @click.prevent="emitRegionData" class="form-btn">
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";

export default {
  mixins: [ValidationMixin],
  props: {
    region: {
      type: Object,
      default: () => {
        return {
          name: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    region: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    nameErrors() {
      return this.handleFieldErrors(this.$v.region.name);
    },
  },
  methods: {
    emitRegionData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.region.name,
        };

        this.region.id ? (data.id = this.region.id) : false;

        this.$emit("emitRegionData", data);

        this.region.name = null;
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
